import React from 'react'

import { Box, BoxProps } from '../Box'
import { formatCurrency, FormatCurrencyOptions } from '../../utils/formatCurrency'

export interface PriceProps extends BoxProps {
  children?: string
  value?: number
  options?: FormatCurrencyOptions
}

export const Price = ({ children, value = 0, options, ...restProps }: PriceProps) => {
  const price = children
    ? typeof children === 'string'
      ? parseInt(children, 10)
      : children
    : value

  return (
    <Box as="figure" {...restProps}>
      {formatCurrency(price / 100, options)}
    </Box>
  )
}

export default Price
